import { Button, ButtonGroup } from 'react-bootstrap';

export default function AudioManagerHeader({ managerMode, onModeChange }) {
  return (
    <div className="flex-shrink-0">
      <h4 className="mb-1 fw-semibold">Audio Manager</h4>
      <div className="d-flex flex-wrap gap-3 text-muted small">
        <span>
          Supported types: <strong>.mp3 &nbsp;.au &nbsp;.opus &nbsp;.vorbis &nbsp;.wav</strong>
        </span>
        <span>
          Max size: <strong>1.5 MB per file</strong>
        </span>
      </div>
      <ButtonGroup className="mt-2 rounded-3 overflow-hidden">
        <Button
          size="sm"
          className={`border-0 rounded-0 px-3 ${
            managerMode === 'audio' ? 'bg-primary-highlight text-white' : 'bg-primary text-white-50'
          }`}
          onClick={() => onModeChange('audio')}
        >
          Assign By Audio
        </Button>
        <Button
          size="sm"
          className={`border-0 rounded-0 px-3 ${
            managerMode === 'device' ? 'bg-primary-highlight text-white' : 'bg-primary text-white-50'
          }`}
          onClick={() => onModeChange('device')}
        >
          Manage By Device
        </Button>
      </ButtonGroup>
    </div>
  );
}
